import { useTranslation } from 'react-i18next';

const OpenBankingExplainer = () => {
  const { t } = useTranslation('Modal', { keyPrefix: 'OpenBankingExplainer' });

  return (
    <div className="flex flex-col gap-6">
      <p>{t('description')}</p>

      <div className="flex flex-col gap-4">
        <h3 className="text-body-semibold">{t('whyKreditzTitle')}</h3>
        <p>{t('whyKreditzDescription')}</p>
      </div>

      <div className="flex flex-col gap-4">
        <h3 className="text-body-semibold">{t('benefitsTitle')}</h3>
        <ul className="my-0 ml-6 list-disc p-0">
          <li>{t('benefit1')}</li>
          <li>{t('benefit2')}</li>
          <li>{t('benefit3')}</li>
        </ul>
      </div>

      <div className="mb-6 flex flex-col gap-4">
        <h3 className="text-body-semibold">{t('safetyTitle')}</h3>
        <p>{t('safetyDescription')}</p>
        <ul className="my-0 ml-6 list-disc p-0">
          <li>{t('safetyPoint1')}</li>
          <li>{t('safetyPoint2')}</li>
          <li>{t('safetyPoint3')}</li>
        </ul>
      </div>
    </div>
  );
};

export default OpenBankingExplainer;
